import { isInSomeRole } from "@/helpers/auth";
import {
  PRICING_TEAM,
  SUPPORT,
  LOYALTY_MARKETING,
  TELNET
} from "@/constants/roles";

export function standardOfferAccess() {
  return isInSomeRole([
    PRICING_TEAM,
    SUPPORT
  ]);
}

export function accountOfferAccess() {
  return isInSomeRole([
    PRICING_TEAM,
    SUPPORT
  ]);
}

export function campaignAccess() {
  return isInSomeRole([
    PRICING_TEAM,
    SUPPORT,
    LOYALTY_MARKETING
  ]);
}

export function associationAccess() {
  return isInSomeRole([
    TELNET,
    PRICING_TEAM,
    SUPPORT
  ]);
}
